var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDice2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55556 0H28.4444C29.3874 0 30.2918 0.374602 30.9586 1.0414C31.6254 1.70819 32 2.61256 32 3.55556V28.4444C32 29.3874 31.6254 30.2918 30.9586 30.9586C30.2918 31.6254 29.3874 32 28.4444 32H3.55556C2.61256 32 1.70819 31.6254 1.0414 30.9586C0.374602 30.2918 0 29.3874 0 28.4444V3.55556C0 2.61256 0.374602 1.70819 1.0414 1.0414C1.70819 0.374602 2.61256 0 3.55556 0ZM7.11111 3.55556C6.16812 3.55556 5.26375 3.93016 4.59695 4.59695C3.93016 5.26375 3.55556 6.16812 3.55556 7.11111C3.55556 8.0541 3.93016 8.95847 4.59695 9.62527C5.26375 10.2921 6.16812 10.6667 7.11111 10.6667C8.0541 10.6667 8.95847 10.2921 9.62527 9.62527C10.2921 8.95847 10.6667 8.0541 10.6667 7.11111C10.6667 6.16812 10.2921 5.26375 9.62527 4.59695C8.95847 3.93016 8.0541 3.55556 7.11111 3.55556ZM24.8889 21.3333C23.9459 21.3333 23.0415 21.7079 22.3747 22.3747C21.7079 23.0415 21.3333 23.9459 21.3333 24.8889C21.3333 25.8319 21.7079 26.7362 22.3747 27.403C23.0415 28.0698 23.9459 28.4444 24.8889 28.4444C25.8319 28.4444 26.7362 28.0698 27.403 27.403C28.0698 26.7362 28.4444 25.8319 28.4444 24.8889C28.4444 23.9459 28.0698 23.0415 27.403 22.3747C26.7362 21.7079 25.8319 21.3333 24.8889 21.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDice2);
export default __webpack_public_path__ + "static/media/dice_2.16e4f099e8b9af07d389dc83c008dc6e.svg";
export { ForwardRef as ReactComponent };